import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { change } from 'redux-form';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  anthropometricMeasurementListById,
  anthropometricMeasurementListByStudent,
  saveMutation,
} from '../../../shared/queries/WeightMeasure';
import GraphQL from '../../../GraphQL';
import WeightMeasureForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  calculateAge,
  formatDays,
  formatMonth,
  formatYear,
  getFormattedDate,
  getDateWithoutTime,
  updatePendency,
} from '../../../shared/utils/smartutils';
import { studentListForAge } from '../../../shared/queries/Student';

const WeightMeasureFormHandler = (props) => {
  const { match, t, history, dispatch, foreignToggleClose } = props;
  const [students, setStudents] = useState([]);
  const [historicalData, setHistoricalData] = useState([]);
  const [excludeDates, setExcludeDates] = useState([]);
  const [dto, setDto] = useState({
    id: 0,
    headDiameter: 0,
    waistCircumference: 0,
  });
  const [formOn, setFormOn] = useState(false);

  function backClickHandler() {
    if (foreignToggleClose) {
      foreignToggleClose();
    } else {
      history.push('/minime/peso-medida');
    }
  }
  function showLoading() {
    dispatch(changeLoadingTrue());
  }
  function hideLoading() {
    dispatch(changeLoadingFalse());
  }
  function findById(id) {
    showLoading();
    const query = anthropometricMeasurementListById(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.anthropometricMeasurementListByFilter) {
          setDto({
            ...res.anthropometricMeasurementListByFilter[0],
            measureDate: getDateWithoutTime(
              res.anthropometricMeasurementListByFilter[0].measureDate
            )
              ? new Date(
                  getDateWithoutTime(
                    res.anthropometricMeasurementListByFilter[0].measureDate
                  )
                )
              : new Date(),
            student: {
              ...res.anthropometricMeasurementListByFilter[0].student,
              label:
                res.anthropometricMeasurementListByFilter[0].student.fullName,
              value: res.anthropometricMeasurementListByFilter[0].student.id,
              age: calculateAge(
                res.anthropometricMeasurementListByFilter[0].student.dateOfBirth
              ),
            },
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      });
  }
  const handleSubmit = (values) => {
    const mutation = saveMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      })
      .finally(() => {
        hideLoading();
        updatePendency(dispatch);
      });
  };

  function loadStudents() {
    showLoading();
    const filter = {
      id: 0,
      classes: [],
      responsibles: [],
      menus: [],
      onlyActive: true,
      onlyWithAccess: true,
    };
    const query = studentListForAge(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.studentListByFilter) {
          const loadedStudents = res.studentListByFilter.map((item) => ({
            ...item,
            value: item.id,
            label: item.fullName.concat(
              ' - ',
              formatYear(item.dateOfBirth, t),
              formatMonth(item.dateOfBirth, t),
              formatDays(item.dateOfBirth, t)
            ),
          }));
          setStudents(loadedStudents);
          hideLoading();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  function loadHistoricalData(studentId) {
    if (studentId) {
      showLoading();
      const query = anthropometricMeasurementListByStudent(studentId);
      GraphQL(query, {})
        .then((res) => {
          if (res.anthropometricMeasurementListByFilter) {
            const loadedHistoricalData =
              res.anthropometricMeasurementListByFilter.map((item) => ({
                ...item,
                formattedMeasureDate: getFormattedDate(
                  getDateWithoutTime(item.measureDate)
                ),
              }));
            const excludeDatesMap = loadedHistoricalData.map((item) =>
              getDateWithoutTime(item.measureDate)
            );
            setExcludeDates(excludeDatesMap);
            setHistoricalData(loadedHistoricalData);
            dispatch(
              change(
                'WeightMeasureForm',
                'historicalData',
                loadedHistoricalData
              )
            );
          }
          hideLoading();
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    } else {
      setHistoricalData([]);
    }
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      loadStudents();
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('mnt_peso_medida.title')}>
      {formOn ? (
        <WeightMeasureForm
          dto={dto}
          students={students}
          excludeDates={excludeDates}
          historicalData={historicalData}
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          loadHistoricalData={loadHistoricalData}
        />
      ) : null}
    </SmartCard>
  );
};

WeightMeasureFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  foreignToggleClose: PropTypes.func,
};

WeightMeasureFormHandler.defaultProps = {
  foreignToggleClose: undefined,
};
export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(WeightMeasureFormHandler)
);
